<div id="header" class="header">
    <span mat-dialog-title class="header-title ml-15">{{ labels['label.gb.device_list'] }}</span>
</div>
<div class="h6" [innerHTML]="headerVal"></div>
<mat-dialog-content class="mat-typography dialog_content">
  <div class="table-container">
    <table mat-table [dataSource]="dataSource" id="icmai-device-list-grid">
      <ng-container matColumnDef="model">
        <th mat-header-cell *matHeaderCellDef>
          {{ labels['label.gb.model'] }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element?.model }}
        </td>
      </ng-container>
      <ng-container matColumnDef="keyEpisodeSupported">
        <th mat-header-cell *matHeaderCellDef>
          {{ labels['label.gb.KeyEpisode'] }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element?.keyEpisodeSupported }}
        </td>
      </ng-container>
    @if(isAISupportedClinic){
        <ng-container matColumnDef="aiSupported">
        <th mat-header-cell *matHeaderCellDef>
            {{ labels['label.gb.AI_powered'] }}
        </th>
        <td mat-cell *matCellDef="let element">
            {{ element?.aiSupported }}
        </td>
    </ng-container>
    }
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</mat-dialog-content>
<div class="button-style">
  <button class="merlin-button" mat-raised-button color="primary" mat-dialog-close cdkFocusInitial>
    {{ labels['label.gb.close'] }}
  </button>
</div>
